import { render, staticRenderFns } from "./notificacao.vue?vue&type=template&id=ffa3deee&"
import script from "./notificacao.vue?vue&type=script&lang=js&"
export * from "./notificacao.vue?vue&type=script&lang=js&"
import style0 from "./notificacao.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports